import store from '@/store/store';
import { cityParser } from "@/plugins/city_parser";

export const hasToken = async (to, from, next) => {
  const getIsToken = store.getters.getIsToken
  if (!getIsToken) {
    const name = to.name
    const query = to.query
    const params = to.params
    store.commit('PATH_TEMPORAL', { name, params, query })
    next({ name: 'login', replace: true })
  } else {
    next()
  }
}

export const isLogin = async (to, from, next) => {
  const getIsToken = store.getters.getIsToken
  if (getIsToken) {
    next({ name: 'root' })
  } else {
    next()
  }
}

export const mainView = (to, from, next) => {
  const getIsToken = store.getters.getIsToken
  if (!getIsToken) {
    next({ name: 'superCategories' })
  } else {
    next()
  }
}


export const hasCity = async (to, from, next) => {
  let openCityModal = true;
  const getIsToken = store.getters.getIsToken;
  const userInfo = store.getters.getUser;
  const storeCity = store.getters.getCity;
  let cartCommerceId = null;
  if(store.getters.getCart && store.getters.getCart.commerce_id) {
    cartCommerceId = store.getters.getCart.commerce_id;
  }
  const urlCity = await store.dispatch("action_getCityByParsedName", to.params.city_id);
  const getCityFunction = async (cityCode) => {
    await store.dispatch("action_getCity", cityCode);
  }
  if(!userInfo && !storeCity && !cartCommerceId && !urlCity) {
    openCityModal = false;
    await getCityFunction(3);
  } else {
    if (getIsToken && userInfo) {
      if (userInfo.commerce_id) {
        if(urlCity && urlCity.code && userInfo.commerce_id == urlCity.code) {
          await getCityFunction(userInfo.commerce_id);
        } else if(!urlCity || !urlCity.code) {
          await getCityFunction(userInfo.commerce_id);
        } else {
          openCityModal = false;
        }
      }
    } else if (urlCity && urlCity.code) {
      if(cartCommerceId) {
        if(cartCommerceId == urlCity.code) {
          await getCityFunction(urlCity.code)
        } else {
          openCityModal = false;
        }
      } else {
        await getCityFunction(urlCity.code);
      }
    } else if (storeCity && storeCity.id) {
      if(cartCommerceId) {
        if(!storeCity.isDefault && storeCity.id == cartCommerceId) {
          await getCityFunction(storeCity.id);
        }
      } else if(!storeCity.isDefault && storeCity.id) {
        await getCityFunction(storeCity.id);
      } else {
        openCityModal = false;
        await getCityFunction(storeCity.id);
      }
    } else {
      openCityModal = false;
      await getCityFunction(3);
    }
  }
  next();
  store.commit('IS_SELECT_COUNTRY', openCityModal);
}

// export const hideShowIntercom = (to, from, next) => {
//   const w = window as any;
//   const isUnderMobile = store.getters.getIsUnderMobile;
//   const toName = to.name;
//     try {
//       if (isUnderMobile && toName && toName === "productDetail") {
//         w.Intercom("update", {
//           hide_default_launcher: true
//         });
//       }
//     } catch (error) {
//       // Do nothing
//     }
// } 